import { useLazyQuery } from "@apollo/client";
import { GET_CATEGORYS } from "../../graphql/category/query";
import _ from "lodash";

export const useQueryCategoryData = () => {
    // apollo client hooks
    const [getCategoryData, { data: loadCategoryData, loading: loadingCategoryDatas, error }] = useLazyQuery(GET_CATEGORYS, {
        fetchPolicy: "cache-and-network",
    });

    // localStorage data 
    const shopData = JSON.parse(localStorage.getItem("SHOP_DATA"))

    // category datas
    const queryCategoryDatas = async ({ _name, }) => {
        try {
            let _where = {
                shop: shopData?.id,
                isDeleted: false,
            }
            if (!_.isEmpty(_name)) {
                _where = {
                    ..._where,
                    name: _name
                }
            }
            await getCategoryData({
                variables: {
                    where: _where,
                }
            });
            if (error) {
                return { error: true, message: `Query Category Data Error: ${error.message}`, error };
            }
            return { data: loadCategoryData };
        } catch (error) {
            return { error: true, message: `Query Category Data Error: ${error.message}`, error };
        }
    };

    return {
        queryCategoryDatas,
        loadCategoryData,
        loadingCategoryDatas,
        error,
    };
};
